import { css } from '@emotion/css';

const style =  {
    container: css({
    }),
};

export default style;